import { VueConstructor, DirectiveOptions } from 'vue';

const IntersectionObserverDirective: DirectiveOptions = {
  inserted(el, binding, vnode) {
    const options = {
      root: null,
      threshold: parseInt(binding.value?.threshold || '0', 10),
      rootMargin: binding.value?.rootMargin || '0px'
    };

    const emit: (event: string) => void = event => {
      if (vnode.componentInstance) {
        vnode.componentInstance.$emit(event);
      } else {
        vnode.elm && vnode.elm.dispatchEvent(new CustomEvent(event));
      }
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          emit('viewport-entered');

          if (binding.value?.singleShot) {
            observer.unobserve(el);
          }
        } else {
          emit('viewport-left');
        }
      });
    }, options);

    observer.observe(el);
  }
};

export default (Vue: VueConstructor) => {
  Vue.directive('intersection-observer', IntersectionObserverDirective);
};
